module.exports = __webpack_public_path__ + "img/4-3.f9f8eb61.png";